import { Dialog, DialogContent } from '@mui/material';
import { useEffect } from 'react';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalEntregaStore,
  type RegistrarPersonaEntrega
} from '../../stores/personal-entrega/personal-entrega.store';
import PersonalEntregaForm from './PersonaEntregaForm';

interface PersonalEntregaAddDialogProps {
  open: boolean;
  onClose: () => void;
  onAddSuccess: (newId: number) => void;
}

const PersonalEntregaAddDialog = ({
  open,
  onClose,
  onAddSuccess
}: PersonalEntregaAddDialogProps) => {
  const { nuevo, registrar } = usePersonalEntregaStore();

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore();
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore();

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = async (values: RegistrarPersonaEntrega) => {
    const result = await registrar(values);
    if (result) {
      onAddSuccess(result);
    }
    return result;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <PersonalEntregaForm
          esAgregar={true}
          ciudades={ciudades}
          estados={estados}
          onSave={handleSave}
          onClose={onClose}
          reloadCiudades={cargarCiudades}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PersonalEntregaAddDialog;
